export default __webpack_public_path__ + "static/media/EconomicsNeedsWants_08.8c3febd6.png";